import Container from '@atoms/Container';
import SvgSafeGatsbyImage from '@atoms/SvgSafeGatsbyImage';
import paddingDefault from '@utils/paddingDefault';
import RichTextEditorStyles from '@utils/RichTextEditorStyles';
import { graphql } from 'gatsby';
import React from 'react';
import NearestVertical from '../franchise/nearest-vertical';
import Col from '../primitives/grid/col';
import Row from '../primitives/grid/row';
import { breakpoints } from '../primitives/tokens';
import { justPTags } from '../utils/just-p-tags';
import { truncateHTML } from '../utils/Truncate';
import Link from "../primitives/link";

const ResourceDetail = ({ data }) => {
    const { title, copy, image, read_more } = data;

    return (
        <div css={paddingDefault()}>
            <Container>
                <Row>
                    <Col breakpoints={{
                        dt: { span: 8 },
                        tb: { span: 12 },
                    }}
                    >
                        {!!image?.url && (
                            <Link css={styles.imageOuterWrap} to={read_more}>
                                <div css={styles.imageInnerWrap}>
                                    <SvgSafeGatsbyImage css={styles.image} image={image} alt={image.description} />
                                </div>
                            </Link>
                        )}
                        <h3 css={styles.title}>
                            <Link title={title} to={read_more}>
                                {title}
                            </Link>
                        </h3>
                        <div
                            css={[RichTextEditorStyles, styles.copy]}
                            dangerouslySetInnerHTML={{
                                __html: copy ? truncateHTML(justPTags(copy), 225) : '',
                            }}
                        />
                        {!!read_more && (
                            <Link css={styles.readMoreLink} to={read_more}>
                                Read More ›
                            </Link>
                        )}
                    </Col>
                    <Col breakpoints={{ dt: { span: 4 }, tb: { span: 12, hidden: true, }, }}>
                        <div css={styles.nearestVerticalWrap}>
                            <NearestVertical />
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

const styles = {
    image: {
        objectFit: "cover",
        width: "100%",
        height: "100%"
    },
    imageInnerWrap: {
        objectFit: "cover",
        position: "absolute",
        top: "0",
        right: "0",
        bottom: "0",
        left: "0"
    },
    imageOuterWrap: {
        display: "block",
        position: "relative",
        marginBottom: "1.5rem",
        "::before": {
            display: "block",
            paddingTop: "64%",
            content: "''",
        }
    },
    title: {
        marginBottom: "0.75rem",
        fontSize: "1.875rem",
        lineHeight: "1.75rem",
        letterSpacing: "0.025em"
    },
    readMoreLink: {
        fontWeight: 600,
        marginTop: "0.75rem",
        fontSize: "1.25rem",
        lineHeight: "1.75rem",
        fontWeight: 600
    },
    copy: {
        paddingBottom: "1rem",
        fontSize: "1.25rem",
        lineHeight: "1.75rem"
    },
    nearestVerticalWrap: {
        position: 'sticky',
        top: '174px',
        paddingBottom: '24px',
        [breakpoints.tb]: {
            paddingBottom: '32px',
        },
    },
};

export const query = graphql`
  fragment ResourceDetailData on CmsPageBuilderBlocks {
    resource_detail {
      copy
      image {
        filename
        title
        url
        description
        contentStackAsset(width: 1440)
      }
      read_more {
        href
        title
      }
    }
  }
`;

export default ResourceDetail;
